module.exports = __webpack_public_path__ + "img/about-position.jpg?2f26143e3353c8828c4237f5fe613bd0";